import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import Successbox from 'components/Web_User_Interface/1440p_Series/Smarthome/Google_Nest/SuccessBox';
export const _frontmatter = {
  "title": "Smarthome Menu // INSTAR Google Nest",
  "path": "/Web_User_Interface/1440p_Serie/Smarthome/Google_Nest/",
  "dateChanged": "2022-05-16",
  "author": "Mike Polinowski",
  "excerpt": "Mit der Google Home-App können Sie Google Nest- oder Home-Lautsprecher und -Displays sowie Chromecast einrichten und steuern. Sie können Tausende von kompatiblen Lampen, Kameras, Lautsprechern und mehr steuern.",
  "image": "./WebUI_1440p_SearchThumb_Smarthome_Alexa.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SuccessBox = makeShortcode("SuccessBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Smarthome Menu // INSTAR Google Nest' dateChanged='2022-05-16' author='Mike Polinowski' tag='INSTAR IP Camera' description='Mit der Google Home-App können Sie Google Nest- oder Home-Lautsprecher und -Displays sowie Chromecast einrichten und steuern. Sie können Tausende von kompatiblen Lampen, Kameras, Lautsprechern und mehr steuern.' image='/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Smarthome/Google_Nest/' locationFR='/fr/Web_User_Interface/1440p_Series/Smarthome/Google_Nest/' crumbLabel="Google Home" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "smarthome-menu",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#smarthome-menu",
        "aria-label": "smarthome menu permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Smarthome Menu`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/bacf2a6049a78852493f624a07bcd4c3/3c492/1440p_Settings_Smarthome_Google.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "73.04347826086956%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACs0lEQVQ4y6WSS2sbVxiG9SsCxQtbl5FGIxmSWrfxjOaqqyV7PBqNq4tjTE1wmkvrQpM4hkBNC6W5OJBNisF2E9JVG2ghi0JTumg2gSy8yiY/5gkzvlQyZBG6ePjO+Tjn4T3fTCSbzSJJElImQzIRI5vXcW78TPPrA6pf7WF/OcL1vbDX3fqFabnOxCfnyOXz5HI5JiYmiEajREKZJJFOp0kKArJq0V/fpH/59im9kdpb32TwxRZls8nMhRzKrBaSmyly/vwMkUwm858wlUJVyix5i/R8N8TvOCx5Tlj9zkJYvcU2njegUmlTVk20soWhVykVlSNhIAuFySSqotHrDxgMhkcMhwyHywyO6ff6+L7PkrdG03awTRNDt9FUi0JBPitMUVa18ILvd8PaDdbdLp7r0HEdWs4CjVaLjd4yq0sujbqOoVthykJh9miGowl1TaPb9XDdDh3Po+O6eJ8N6W48oL9+hx+b82xWGnx7xWfjco35th4+W9csioFwdIapVAq5pOAuzjPoL9CaqzPfatJoNKm3Pdpth8Fcje1bN3my+wNXV02qloapG1RMk1JJHk8oiimKBRnbruI4VWpVHcvQqVdMnEaFS5+vcHDwmNev/+Xtn79z//pFbEOlZhlULINSsTQ+wyBhqaRgmzWajToVy6TVaPHw+294uv8TL/76h8M3rzh89TfvXr7kxfYWbl0PP4xlHD95NGEgzOcKKHIZZbaMbRhcXVthd+c7Hty/x/M/nvPrwSOe7Nzlt2f77Ny4xkpLRZYVlFmVmU/z4wlFUSQWixGNxsK/XkjESScTiEmBRCIR7gUhQTKVREyLCEE/Hh27EwkkASfCoDk1NXXK5GTA5DFn95NjZwMiJ6JR4f8hIoai9AcTfiwRKZslk51GymRJSxkEQTglmFs8Hv8o3gPigwp3di505AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bacf2a6049a78852493f624a07bcd4c3/e4706/1440p_Settings_Smarthome_Google.avif 230w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/d1af7/1440p_Settings_Smarthome_Google.avif 460w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/7f308/1440p_Settings_Smarthome_Google.avif 920w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/a2baf/1440p_Settings_Smarthome_Google.avif 1300w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/bacf2a6049a78852493f624a07bcd4c3/a0b58/1440p_Settings_Smarthome_Google.webp 230w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/bc10c/1440p_Settings_Smarthome_Google.webp 460w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/966d8/1440p_Settings_Smarthome_Google.webp 920w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/063bf/1440p_Settings_Smarthome_Google.webp 1300w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bacf2a6049a78852493f624a07bcd4c3/81c8e/1440p_Settings_Smarthome_Google.png 230w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/08a84/1440p_Settings_Smarthome_Google.png 460w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/c0255/1440p_Settings_Smarthome_Google.png 920w", "/de/static/bacf2a6049a78852493f624a07bcd4c3/3c492/1440p_Settings_Smarthome_Google.png 1300w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/bacf2a6049a78852493f624a07bcd4c3/c0255/1440p_Settings_Smarthome_Google.png",
              "alt": "Web User Interface - 1440p Serie - Smarthome Google Nest",
              "title": "Web User Interface - 1440p Serie - Smarthome Google Nest",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      